import axios from "axios";

const client = axios.create({
  baseURL: "https://lab.teamyab.com/api",
});

export const get = (path, params = null) => {
  let headers = {};

  const onSuccess = (response) => {
    console.error("Get Request Successful!");
    return response.data;
  };

  const onError = (error) => {
    console.error("Get Request Failed:");
    console.error(error);

    return Promise.reject(error.response || error.message);
  };

  return client
    .get(path, {
      params: params,
      headers,
    })
    .then(onSuccess)
    .catch(onError);
};

export function post(path, data, token, params) {
  let headers = {}

  const onSuccess = (response) => {
      console.error('Post Request Successful!')
      return response.data
  }

  const onError = (error) => {
      console.error('Post Request Failed:')
      console.error(error)

      return Promise.reject(error.response || error.message)
  }

  return client.post(path, data, {
      headers,
      params
  })
      .then(onSuccess)
      .catch(onError);
}